export interface NextDrawInfo {
  at: Date;
  date: string;
  label: string;
}

const TT_OFFSET_MS = 4 * 60 * 60 * 1000; // AST is UTC-4 year-round.
const DRAW_DAYS = new Set([3, 6]); // Wednesday, Saturday in local TT wall-clock day.

export const getNextNLCBDraw = (now = new Date()): NextDrawInfo => {
  const ttWallClock = new Date(now.getTime() - TT_OFFSET_MS);

  for (let add = 0; add <= 7; add += 1) {
    const localCandidate = new Date(Date.UTC(
      ttWallClock.getUTCFullYear(),
      ttWallClock.getUTCMonth(),
      ttWallClock.getUTCDate() + add,
      20,
      30,
      0,
      0,
    ));

    if (!DRAW_DAYS.has(localCandidate.getUTCDay())) continue;

    const actualInstant = new Date(localCandidate.getTime() + TT_OFFSET_MS);
    if (actualInstant.getTime() <= now.getTime()) continue;

    const year = localCandidate.getUTCFullYear();
    const month = String(localCandidate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(localCandidate.getUTCDate()).padStart(2, '0');
    const weekday = localCandidate.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });

    return {
      at: actualInstant,
      date: `${year}-${month}-${day}`,
      label: `${weekday} 8:30 PM AST`,
    };
  }

  throw new Error('Unable to calculate the next NLCB Lotto Plus draw.');
};

export const formatCountdown = (target: Date, now = new Date()) => {
  const totalSeconds = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const hh = String(hours).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return days > 0 ? `${days}d ${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`;
};
